import React from "react";
import { FaCarSide, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import {   FaFacebookF, FaInstagram, FaTwitter, FaLinkedin, FaWhatsapp } from "react-icons/fa";

// Auto slug generator
const slugify = (text) =>
  "/" +
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// All Mumbai keywords
const keywords = [
  "Mumbai Outstation Cabs",
  "Mumbai to Mahabaleshwar Cab",
  "Mumbai to Goa Cabs",
  "Mumbai to Shirdi Cab",
  "Mumbai Nashik Cab",
  "Mumbai to Kolhapur Cab",
  "Mumbai to Pune Cab",
  "Mumbai to Aurangabad Cab",
  "Mumbai to Bhimashankar Cab",
  "Mumbai to Ashtavinayak Cab Service",
  "Mumbai to 5 Jyotirlinga Cab",
  "Mumbai to Lonavala Cab",
  "Mumbai to Konkan Darshan Cab Booking",
  "Mumbai to Alibaug Cab",
  "Mumbai to Ahmednagar Cab",
  "Mumbai to Matheran Cab",
  "Mumbai to Jalgaon / Dhule Cab",
  "Mumbai to Lavasa Cab",
  "Mumbai to Panchgani Cab",
  "Mumbai to Khandala Taxi Fare",
  "Mumbai to Surat Cab",
  "Mumbai to Ahmedabad Cab",
  "Mumbai to Narmada Parikrama Cab Booking",
  "Mumbai to Vadodara Cab",
  "Mumbai to Daman Taxi",
  "Mumbai to Vapi Cab",
  "Mumbai to Bangalore Cab",
  "Mumbai to Indore Cab",
  "Mumbai to Jaipur Taxi",
  "Mumbai Airport to Pune Cabs",
  "Mumbai to Imagica Cab",
  "Cab Service in Mumbai",
  "Best Taxi Service in Mumbai",
  "Online Taxi Booking Mumbai",
  "Mumbai Darshan Cabs",
  "Wedding Car Rental Mumbai",
  "One Way Cab Service",
  "Corporate Cab Services in Mumbai",
  "Cab Companies in Mumbai",
  "Mumbai Car Rental Service",
  "Round Trip Cab Booking Mumbai",
  "Cab Service in Thane",
  "Cab Service Near Me Mumbai",
  "Swift Dzire on Rent in Mumbai",
  "Cab Service in Navi Mumbai",
  "Taxi Service at Mumbai International Airport",
  "Cab Service in Kalyan / Dombivali",
  "Innova Car Rental Mumbai",
  "Innova Crysta on Rent in Mumbai",
  "Ertiga on Rent in Mumbai",
  "Sedan Cab Service Mumbai",
  "Tempo Traveller on Rent Mumbai",
  "Mini Bus on Rent in Mumbai",
  "Kia Carens Cab Service in Mumbai",
  "Toyota Etios on Rent in Mumbai",
  "Car Rental Mumbai",
  "Explore India / Pan India Cab Booking Services",
  "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
  "Outstation Taxi Service in Mumbai",
  "Car Hire for Outstation in Mumbai",
  "Mumbai to Hyderabad Cabs",
  "Mumbai Cab Service",
  "Best Cab Service in Mumbai",
  "Mumbai to Ayodhya Cab",
  "Mumbai to Saputara Cabs",
  "Mumbai to Bhopal Cab",
  "Mumbai to Telangana Cab Service",
  "Mumbai to Shani Shingnapur Cab",
  "Mumbai to Trimbakeshwar Cab",
  "Mumbai Airport to Vadodara Cab",
  "Mumbai to Solapur Cab",
  "Mumbai to Ratnagiri Cab",
  "Mumbai to Grishneshwar Cab",
  "Mumbai to Palghar Cab",
  "Mumbai to Ujjain Cab",
  "Mumbai to Jaipur Cab",
  "Mumbai to Gujarat Cab",
  "Innova on Rent Mumbai",
  "Kia Carens on Rent in Mumbai"
];

// Split keywords into 3 columns
const chunkSize = Math.ceil(keywords.length / 3);
const column1 = keywords.slice(0, chunkSize);
const column2 = keywords.slice(chunkSize, chunkSize * 2);
const column3 = keywords.slice(chunkSize * 2);

const Footer = () => {
  const renderColumn = (title, items) => (
    <div>
      <h3 className="footer-title">{title}</h3>
      <ul className="footer-list">
        {items.map((item, index) => (
          <li key={index}>
            <FaCarSide />
            <a href={slugify(item)}>{item}</a>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer className="gauto-footer-area">
      <div className="footer-container">
        <div className="footer-grid">

          {renderColumn("Mumbai Cab Services", column1)}
          {renderColumn("Popular Routes & Outstation", column2)}
          {renderColumn("Fleet & Rental Services", column3)}

          {/* Contact / Address */}
          <div>
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li><FaPhone /> <a href="tel:+919819399797">+91 9819399797</a></li>
              <li><FaEnvelope /> <a href="mailto:booking@shambhucab.com">booking@shambhucab.com</a></li>
              <li>
                <FaMapMarkerAlt />
                Shambhu Cabs   </li>
                Saket Tata Power CHS, Swami Samarth Marg,
                Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                Maharashtra India - 400703
           
            </ul>
            
{/* Social Media Icons */}
  <div className="footer-social mt-3 py-md-3">
    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
    <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
    <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
    <a href="https://wa.me/919819399797" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
  </div>
{/* 
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.7268196767427!2d73.0012643!3d19.075744900000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c10069d51255%3A0x212370c985b54f65!2sSaket%20Tata%20Power%20CHS!5e0!3m2!1sen!2sin!4v1765105944790!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}



          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d397811.6763945419!2d72.69586406522716!3d19.075746183373056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xaecf06ffbc56e61f%3A0x9987fb9eb65682d3!2sShambhu%20Cabs!5e1!3m2!1sen!2sin!4v1766463527185!5m2!1sen!2sin" widtwidth="100%" height="250"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>



        </div>

        <div className="footer-bottom">
          <p className="copyright-text text-white">
                All Rights Reserved &copy;  <span className="darkcolor">Shambhu Cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolor">&nbsp;Dexter Intelligence</span>
                </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolor">&nbsp;Urva Hosting</span>
                </a>
              </p>
          {/* © {new Date().getFullYear()} Shambhu Cabs — All Rights Reserved. */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
